<template>
  <a-modal
    centered
    :title="title"
    v-model="visible"
    width="600px"
    :maskClosable="false"
    :destroyOnClose="true"
    @ok="onSubmit"
  >
    <a-table
      size="small"
      :pagination="false"
      rowKey="Id"
      :data-source="editData"
    >
      <a-table-column key="Name" title="名称" data-index="Name">
      </a-table-column>
      <a-table-column
        key="Quantity"
        title="数量"
        data-index="Quantity"
        width="130px"
        align="center"
      >
        <template slot-scope="text, record">
          <a-input-number v-model="record.Quantity" />
        </template>
      </a-table-column>
      <a-table-column
        key="Id"
        title="操作"
        data-index="Id"
        width="100px"
        align="center"
      >
        <template slot-scope="text, record">
          <a @click="updateFood(record)">更换</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定移除吗?"
            ok-text="确认"
            cancel-text="取消"
            @confirm="removeRow(text)"
          >
            <a>移除</a>
          </a-popconfirm>
        </template>
      </a-table-column>
    </a-table>
    <a-button @click="addFood" style="margin-top:10px">+ 添加菜品</a-button>
  </a-modal>
</template>
<script>
import cloneDeep from "lodash/cloneDeep";
import foodSelectModal from "../foodSelect/boot.js";
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "编辑套餐菜品"
    },
    data: {
      type: Array,
      default: () => []
    },
    submit: Function
  },
  data() {
    return {
      visible: true,
      editData: []
    };
  },

  created() {
    this.editData = cloneDeep(this.data);
  },
  methods: {
    updateFood(item) {
      const { editData } = this;
      const that = this;
      foodSelectModal({
        submit: selected => {
          if (selected && selected.length) {
            const sel = selected[0];
            const hasFind = editData.find(p => p.Id === sel.DishId);
            if (hasFind && hasFind.Id) {
              that.$message.error("所选菜品已存在，请直接修改数量");
              return false;
            }
            const newData = editData.map(p => {
              if (p.Id === item.Id) {
                return {
                  Id: sel.DishId,
                  Name: sel.DishName,
                  Quantity: item.Quantity
                };
              }
              return p;
            });
            that.editData = newData;
          }
        }
      });
    },
    onSubmit() {
      this.visible = false;
      this.$emit("submit", this.editData);
    },
    removeRow(id) {
      this.editData = this.editData.filter(p => p.Id !== id);
    },
    addFood() {
      const { editData } = this;
      const that = this;
      foodSelectModal({
        submit: selected => {
          if (selected && selected.length) {
            const ids = editData.map(p => p.Id);
            const addRows = selected
              .filter(p => !ids.includes(p.DishId))
              .map(sel => {
                return {
                  Id: sel.DishId,
                  Name: sel.DishName,
                  Quantity: 1
                };
              });
            that.editData = [...editData, ...addRows];
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
